import React from 'react'

const Headerimage = (props) => {
    return (
        <div className='headerimg'>
            <div className='overlay' style={{
                backgroundImage: `url(${props.image})`,
                backgroundRepeat: 'no - repeat',
                backgroundSize: 'cover'
            }}>
                <div className='over'></div>
                <div className=" imgtopheading" >
                    <div className='container'>
                        <p>{props.title}</p>
                    </div>
                </div>
            </div>

        </div >
    )
}

export default Headerimage